export enum EFGColorGunTargetType {
  ECGT_noTarget,
  ECGT_nonColorable,
  ECGT_validTarget,
  ECGT_sameColorSlot,
}
